import { callable } from '../callable';

export interface SubmitSeminaryRequestInput {
  seminaryName: string;
  contactName: string;
  contactEmail: string;
  contactPhone?: string;
  country?: string;
  estimatedSize?: string;
  message?: string;
  suggestedSlug?: string;
}

export type SeminaryRequestStatus = 'pending' | 'approved' | 'rejected';

export interface SeminaryRequestRecord {
  id: string;
  seminaryName: string;
  suggestedSlug: string;
  contactName: string;
  contactEmail: string;
  contactPhone?: string;
  country?: string;
  estimatedSize?: string;
  message?: string;
  status: SeminaryRequestStatus;
  tenantId?: string;
  rejectionReason?: string;
  reviewedBy?: string;
  reviewedAt?: string;
  createdAt?: string;
}

export const onboardingApi = {
  submit: async (data: SubmitSeminaryRequestInput) => {
    const fn = callable<SubmitSeminaryRequestInput, { requestId: string; status: string }>(
      'submitSeminaryRequest',
    );
    return (await fn(data)).data;
  },

  list: async (status?: SeminaryRequestStatus) => {
    const fn = callable<{ status?: SeminaryRequestStatus }, { requests: SeminaryRequestRecord[] }>(
      'listSeminaryRequests',
    );
    return (await fn(status ? { status } : {})).data;
  },

  approve: async (data: { requestId: string; finalSlug: string }) => {
    const fn = callable<typeof data, { tenantId: string; slug: string }>('approveSeminaryRequest');
    return (await fn(data)).data;
  },

  reject: async (data: { requestId: string; reason: string }) => {
    const fn = callable<typeof data, { success: boolean }>('rejectSeminaryRequest');
    return (await fn(data)).data;
  },
};
